import { createStore } from 'vuex'
import CentroMedico from './modules/CentroMedico.module';
import Appuntamento from './modules/Appuntamento.module';

export default createStore({
  modules: {
    CentroMedico,
    Appuntamento
  }
})
